import { ENGLISH_IQ_MILESTONES_SECONDS } from '@repo/config';

interface IEnglishIqQuestionProgress {
  minutes: number;
  progress: number;
}

export function getEnglishIqQuestionProgress(elapsedSeconds: number): IEnglishIqQuestionProgress {
  const nextMark =
    ENGLISH_IQ_MILESTONES_SECONDS.find((mark) => mark > elapsedSeconds) ??
    ENGLISH_IQ_MILESTONES_SECONDS.at(-1) ??
    60;
  const previousMark =
    [...ENGLISH_IQ_MILESTONES_SECONDS].reverse().find((mark) => mark <= elapsedSeconds) ?? 0;
  return {
    minutes: Math.max(1, Math.ceil((nextMark - elapsedSeconds) / 60)),
    progress: Math.min(
      100,
      ((elapsedSeconds - previousMark) / Math.max(1, nextMark - previousMark)) * 100,
    ),
  };
}
